import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';
import {
  CircularProgress,
  ClickAwayListener,
  IconButton,
  makeStyles,
  TextField,
  Typography,
} from '@material-ui/core';

import { SearchRoundIcon } from '../../../../constants';
// VINPlaceholder remove from contants import not to display svg in vin search
import { Style } from './Style';
import Buttons from '../Buttons';
import VehicleInfo from '../VehicleInfo';

import { VinApi } from '../../../../utils/vin-api';
import { Toast } from '../../../Toast/Toast';
import VehicleFields from '../VehicleFields';

const useStyles = makeStyles(() => Style());

export default function VinLookup({ setToggle }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const [vinLoader, setVinLoader] = useState(false);
  const [showVinSearchVehicles, setShowVinSearchVehicles] = useState(false);
  const [vinSearchVehicles, setVinSearchVehicles] = useState([]);

  const [vinSearchValue, setVinSearchValue] = useState('');

  const selectedVehicle = useSelector(
    (state) =>
      state.customerVehicleSearch?.selectedCustomerAndVehicle?.vehicle || '',
  );

  const createVehicleLoading = useSelector(
    (state) => state.vehicle?.createVehicleLoading || false,
  );

  const generateROLoading = useSelector(
    (state) => state?.ro?.generateROLoading || false,
  );

  const pathname = history.location?.pathname || '';

  const [vehicle, setVehicle] = useState({
    displacement: null,
    engineDisplacementType: 'Liters',
  });

  const clearVehicleInfoOnHeader = (payload = '') => {
    if (
      !(
        selectedVehicle?.id &&
        (pathname.includes('/estimator') ||
          pathname.includes('/new-repairorder'))
      )
    ) {
      dispatch({ type: 'SET_VEHICLE_INFO_ON_HEADER', payload });
    }
  };

  // handle VIN data
  const handleVINData = async (vin = '') => {
    if (vin?.length === 17) {
      try {
        if (vin?.length < 17) {
          return;
        }
        /* ==========VIN API CALL============== */
        setVinSearchVehicles([]);
        setVinLoader(true);
        setVehicle();
        clearVehicleInfoOnHeader();

        const result = await VinApi(vin);

        setVinLoader(false);

        const { data: { vinData = [] } = '' } = result || '';

        if (vinData?.length && vin) {
          vinData.map((d) => {
            d.vin = d.vin || vin;
            return d;
          });
        }
        setShowVinSearchVehicles('vin');

        setVinSearchVehicles(vinData);
      } catch (error) {
        const err = 'Invalid VIN';
        Toast('error', error?.response?.data?.message || err);

        setVinLoader(false);
        return error;
      }
    }
  };

  const onSelectVehicle = (vinData = '') => {
    if (vinData) {
      let displacement = null;
      let displacementType = 'Liters';
      let transmissionStyle = '';

      const { DisplacementCC = '', TransmissionStyle = '' } = vinData || '';

      let { DisplacementL = '' } = vinData || '';

      DisplacementL = DisplacementL?.replace('L', '') || '';

      if (DisplacementL) {
        displacement = DisplacementL || null;
        displacementType = 'Liters';
      } else if (DisplacementCC) {
        displacement = DisplacementCC || null;
        displacementType = 'CC';
      }

      if (TransmissionStyle?.toLowerCase()?.includes('manual')) {
        transmissionStyle = 'Manual';
      } else if (TransmissionStyle?.toLowerCase()?.includes('automatic')) {
        transmissionStyle = 'Auto';
      }

      const vehicleInfo =
        vinData?.DisplayName ||
        vinData?.ModelYear + ' ' + vinData?.Make + ' ' + vinData?.Model;
      setVehicle({
        ...vehicle,
        vehicleType: vinData?.VehicleType || '',
        noOfCylinder: vinData?.EngineCylinders || '',
        vin: vinData?.vin || '',
        fuelType: vinData?.FuelTypePrimary || '',
        vehicleMake: vinData?.Make || '',
        vehicleModel: vinData?.Model || '',
        modelYear: vinData?.ModelYear || '',
        notes: vinData?.Note || '',
        displacement: displacement || null,
        engineDisplacementType: displacementType,
        transmission: transmissionStyle,
        submodel: vinData?.Submodel,
        baseVehicleId: vinData?.baseVehicleId || '',
        engineId: vinData?.engineId || '',
        mcNumber: vinData?.mcNumber || '',
        unitNumber: vinData?.unitNumber || '',
        vehicleInfo,
      });

      clearVehicleInfoOnHeader(vehicleInfo);
    }
    setShowVinSearchVehicles(false);
  };

  const clearState = () => {
    setVinLoader(false);
    setShowVinSearchVehicles(false);
    setVinSearchVehicles([]);
    setVinSearchValue('');
    setVehicle({ displacement: null, engineDisplacementType: 'Liters' });
    clearVehicleInfoOnHeader();
  };

  const handleChangeLicensePlate = (licensePlate) => {
    setVehicle({
      ...vehicle,
      licensePlate,
    });
  };

  const vehicleDetails = () => {
    delete vehicle.vehicleInfo;

    return vehicle;
  };

  const handleChangeUnitNumber = (e) => {
    const { value } = e.target;
    setVehicle({
      ...vehicle,
      unitNumber: value,
    });
  };

  const handleChangeMcNumber = (e) => {
    const { value } = e.target;
    setVehicle({
      ...vehicle,
      mcNumber: value,
    });
  };
  return (
    <div>
      <VehicleInfo
        vehicleInfo={vehicle?.vehicleInfo || ''}
        onClear={clearState}
        disabled={vinLoader || createVehicleLoading || generateROLoading}
      />

      {/* VIN LookUp */}

      <div className={clsx(classes.flex__bw)}>
        <div className={classes.texts__side}>
          <Typography className={classes.heading}>VIN Lookup</Typography>
          <Typography className={classes.para}>
            Enter Vehicle Identification Number to search vehicle
          </Typography>
        </div>
        <div className={clsx('d-flex p-relative', classes.width__fields)}>
          <TextField
            type='text'
            name='search'
            placeholder='Vehicle Information'
            value={vinSearchValue || ''} // vehicle?.vin ||
            fullWidth
            // InputProps={{
            //   endAdornment: vinLoader ? (
            //     <CircularProgress size={12} />
            //   ) : (
            //     <VINPlaceholder className={classes.icon} />
            //   ),
            //   disableUnderline: true,
            // }}
            InputProps={{
              endAdornment: vinLoader && <CircularProgress size={12} />,
              disableUnderline: true,
            }}
            disabled={vinLoader}
            onChange={(e) => {
              if (e.target.value?.length > 17) return;
              setVinSearchValue(e.target.value);
            }}
            className={classes.data__field}
          />
          <IconButton
            className={clsx(
              classes.search__round__btn,
              vinLoader && classes.disbale__icon__search,
            )}
            disbaled={vinLoader}
            onClick={() => !vinLoader && handleVINData(vinSearchValue)}
          >
            <SearchRoundIcon />
          </IconButton>
          {showVinSearchVehicles === 'vin' && (
            <ClickAwayListener
              onClickAway={() => {
                setVinSearchVehicles([]);
              }}
            >
              <div className={classes.root__dropdown__main}>
                {vinSearchVehicles?.map((veh, key) => {
                  return (
                    <Typography
                      className={clsx(classes.dropdown__menu__text)}
                      onClick={() => {
                        onSelectVehicle(veh);
                      }}
                      key={key++}
                    >
                      {veh?.DisplayName}
                    </Typography>
                  );
                })}
              </div>
            </ClickAwayListener>
          )}
        </div>
      </div>
      <VehicleFields
        vehicleData={vehicle}
        handleChangeLicensePlate={handleChangeLicensePlate}
        handleChangeUnitNumber={handleChangeUnitNumber}
        handleChangeMcNumber={handleChangeMcNumber}
        usedIn='vin'
      />

      {/* Actions */}

      <Buttons
        onCancel={() => {
          clearState();
          setToggle(false);
        }}
        getVehicleObj={vehicleDetails}
        disabled={
          !vehicle?.vehicleMake ||
          !vehicle?.vehicleModel ||
          !vehicle?.modelYear ||
          !vehicle?.licensePlate
        }
      />
    </div>
  );
}
